// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3eMWh","fileBtn":"File_fileBtn__2Nwvr","closeBtn":"File_closeBtn__23a-W","fileSelected":"File_fileSelected__1KycL","disabled":"File_disabled__1Llid"};